import { useState, useEffect } from 'react';
import { getCurrentUserInfo } from '../services/calendarApi';

export const useAuth = () => {
  const [currentUser, setCurrentUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadUserInfo = async () => {
      try {
        const userInfo = await getCurrentUserInfo();
        setCurrentUser(userInfo);
      } catch (error) {
        console.error('ユーザー情報の取得に失敗:', error);
        setCurrentUser({
          isAuthenticated: false,
          isDesk: false,
          isReporter: false
        });
      } finally {
        setIsLoading(false);
      }
    };
    
    loadUserInfo();
  }, []);

  const displayName = currentUser?.name || currentUser?.username || currentUser?.email || 'ゲスト';

  return { currentUser, isLoading, displayName };
};